import { formatShortDateTimeDisplay } from "@aderant/aderant-react-components";
import React from "react";

const SearchCard = (props) => {
    const { resultItem, onClick } = props;

    const handleSearchCardClick = (id) => {
        if (onClick) {
            onClick(id);
        }
    };

    //Format Date
    const formattedDate = (date?: Date) => (!date ? "-" : formatShortDateTimeDisplay(date));

    return (
        <div className="cards" onClick={() => handleSearchCardClick(resultItem.id)}>
            <div className="cards-header">
                <div>
                    <div className="header-cardName">{resultItem?.name}</div>
                    <div className="header-subName">{`Results as of ${
                        resultItem?.searchDate
                            ? formattedDate(resultItem.searchDate)
                            : "-"
                    }`}</div>
                </div>
            </div>

            <div className="cards-hitContent">
                <div>
                    <div className="label">Request Status</div>
                    <div className="label-value" style={{ fontWeight: 600 }}>
                        {resultItem?.status ? resultItem.status : "-"}
                    </div>
                </div>

                <div>
                    <div className="label">Assigned To</div>
                    <div className="label-value" style={{ fontWeight: 600 }}>
                        {resultItem?.assignedToUser?.name ? resultItem.assignedToUser.name : "-"}
                    </div>
                </div>

                <div>
                    <div className="label">Search Description</div>
                    <div className="label-value" style={{ fontWeight: 600 }}>
                        {resultItem?.description ? resultItem.description : "-"}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SearchCard;
